import axios from "../libs/axios";
import { handleSuccess, handleError } from "./response-handler";

const namespace = "printer";

const api = {
  async getVehiclePrintData(vehicleId, fromDate, toDate) {
    try {
      const response = await axios.get(`vehicles/${vehicleId}/print`, {
        params: {
          from: fromDate,
          to: toDate,
        },
      });
      return handleSuccess(
        { namespace, action: "getVehiclePrintData" },
        response,
      );
    } catch (error) {
      return handleError(
        { namespace, action: "getVehiclePrintData" },
        error.response,
      );
    }
  },

  async getVehicleInfo(vehicleId) {
    try {
      const response = await axios.get(`vehicles/${vehicleId}`);
      return handleSuccess({ namespace, action: "getVehicleInfo" }, response);
    } catch (error) {
      return handleError(
        { namespace, action: "getVehicleInfo" },
        error.response,
      );
    }
  },

  async getCurrentTemperatures(vehicleId) {
    try {
      const response = await axios.get(`services/eyecold/${vehicleId}`);
      return handleSuccess(
        { namespace, action: "getCurrentTemperatures" },
        response,
      );
    } catch (error) {
      return handleError(
        { namespace, action: "getCurrentTemperatures" },
        error.response,
      );
    }
  },
};

export default api;
